var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLencoPayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2.5H3.33333C2.97971 2.5 2.64057 2.64048 2.39052 2.89052C2.14048 3.14057 2 3.47971 2 3.83333V13.1667C2 13.5203 2.14048 13.8594 2.39052 14.1095C2.64057 14.3595 2.97971 14.5 3.33333 14.5H12.6667C13.0203 14.5 13.3594 14.3595 13.6095 14.1095C13.8595 13.8594 14 13.5203 14 13.1667V3.83333C14 3.47971 13.8595 3.14057 13.6095 2.89052C13.3594 2.64048 13.0203 2.5 12.6667 2.5ZM12.6667 13.1667H3.33333V3.83333H12.6667V13.1667ZM7.33333 11.1667H6.66667C5.59333 11.1667 4 10.46 4 8.5C4 6.54667 5.59333 5.83333 6.66667 5.83333H7.33333V7.16667H6.66667C6.36 7.16667 5.33333 7.28 5.33333 8.5C5.33333 9.76667 6.44667 9.83333 6.66667 9.83333H7.33333V11.1667ZM9.33333 11.1667H8.66667V9.83333H9.33333C9.64 9.83333 10.6667 9.72 10.6667 8.5C10.6667 7.23333 9.55333 7.16667 9.33333 7.16667H8.66667V5.83333H9.33333C10.4067 5.83333 12 6.54667 12 8.5C12 10.46 10.4067 11.1667 9.33333 11.1667ZM10 9.16667H6V7.83333H10V9.16667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLencoPayIcon);
export default __webpack_public_path__ + "static/media/lencoPayIcon.3efc3a49.svg";
export { ForwardRef as ReactComponent };